// ======================================================================
// File Name       : TrialExpireNotice
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Button, Col } from 'react-bootstrap';
import Header from '../../components/Header';
import { MULTI_LANGUAGE_LIST } from '../../constants/PathConstants';
import { Link } from 'react-router-dom';
import SystemNoticeList from '../../containers/top/SystemNoticeList';
import NoticeDetail from '../../containers/top/NoticeDetail';
import { setGTMConfig } from '../../utils/PageUtils';
import {
  NEW_USER_MANAGEMENT_URL,
} from "../../constants";
import { CREDIT_CHECKED_FLAG_STATUS } from '../../constants/EnterpriseConstants';

class TrialExpireNotice extends React.Component {

  componentWillMount() {
    setGTMConfig();
    window.appendCorsIframe();
  }
  render() {
    const {
      openPaymentUrl,
      openContactUrl,
      idNum,
      multiLanguagePageNum,
      // sprint_20230522_tma START
      systemNotice,
      onHandleNoticeDetail,
      startPositionSystem,
      getStartEndDataSystem,
      recordNumSystem,
      noticeInfo,
      showDialog,
      onHandleCloseDialog,
      onClickDownload,
      // sprint_20230522_tma END
      creditCheckedFlag,
    } = this.props;
    return (
      <Col sm={12}>
        <Header name="無料トライアル期間が終わりました" />
        <Col sm={12} className="margin-top-20 padding-left-right-clear">
          利用の継続をご希望される場合は、契約手続きに進んでください。
        </Col>
        <Col sm={12} className="margin-top-20 padding-left-right-clear bold">
          現在の有効な受講ユーザー数
        </Col>
        <Col sm={12} className="margin-top-20 padding-left-right-clear bold">
          <h1>{idNum} ID</h1>
        </Col>
        <Col sm={12} className="margin-top-20 padding-left-right-clear">
          <p className="margin-top-10">基本利用料金は、受講ユーザー数に応じて変動します。</p>
          <p className="margin-top-10">
            契約のお手続きに進む前に
            <a
              href={NEW_USER_MANAGEMENT_URL}
              className="text-decoration-underline"
            >
              ユーザー管理
            </a>
            で不要なユーザーがいないか確認してください。
          </p>
        </Col>
        {multiLanguagePageNum > 0 &&
          <>
            <hr className="col-sm-12" />
            <Col sm={12} className="padding-left-right-clear bold">
              <p className="margin-top-10">多言語対応済みドキュメント</p>
            </Col>
            <Col sm={12} className="margin-top-20 padding-left-right-clear bold">
              <h1>{multiLanguagePageNum} ページ</h1>
            </Col>
            <Col sm={12} className="margin-top-20 padding-left-right-clear">
              <p className="margin-top-10">多言語対応済みドキュメントがあります。</p>
              <p className="margin-top-10">
                契約のお手続きに進む前に不要な
                <Link to={MULTI_LANGUAGE_LIST} className="text-decoration-underline">
                  多言語対応
                </Link>
                のドキュメントがないか確認してください。
              </p>
            </Col>
          </>
        }
        {creditCheckedFlag === CREDIT_CHECKED_FLAG_STATUS.NO_PROBLEM && (
          <Col sm={12} className="margin-top-30 padding-left-right-clear">
            <Button
              variant="primary"
              className="btn-120 inquiry-contract-btn-expired"
              onClick={() => {
                openPaymentUrl();
              }}
            >
              契約手続きに進む
            </Button>
          </Col>
         )}
        <hr className="col-sm-12" />
        <Col sm={12} className="margin-top-20 padding-left-right-clear">
          ご質問・相談がある場合はこちらからお問い合わせください。
        </Col>
        <Col sm={12} className="margin-top-20 padding-left-right-clear">
          <Button
            variant="default"
            style={{
              color: '#296fd8',
              borderColor: '#296fd8',
            }}
            className="btn-120 inquiry-contact-btn-expired"
            onClick={() => {
              openContactUrl();
            }}
          >
            担当者と直接話す
          </Button>
        </Col>
        {/* sprint_20230522_tma START */}
        <SystemNoticeList
          systemNotice={systemNotice}
          onHandleNoticeDetail={onHandleNoticeDetail}
          startPositionSystem={startPositionSystem}
          getStartEndDataSystem={getStartEndDataSystem}
          recordNumSystem={recordNumSystem}
        />
        <NoticeDetail
          noticeInfo={noticeInfo}
          showDialog={showDialog}
          onHandleCloseDialog={onHandleCloseDialog}
          onClickDownload={onClickDownload}
        />
        {/* sprint_20230522_tma END */}
      </Col>
    );
  }
}

export default TrialExpireNotice;
